'use strict';

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import Vue from 'vue';
import Configuration from "@/Common/Configuration";
import Utility from "@/Common/Utility"; //import { local } from "d3";
//import moment from "moment";

function TouchEventManager() {
  this.Element = null;
  this.ElementStartX = -1;
  this.ElementStartY = -1;
  this.ElementStartCenterX = -1;
  this.ElementStartCenterY = -1;
  this.ElementStartWidth = -1;
  this.ElementStartHeight = -1;
  this.OffsetX = -1;
  this.OffsetY = -1;
  this.needPreventDefault = true;
  this.lastMultiTouchEndTime = new Date();
  this.lastMultiTouchMoveTime = new Date();
  this.hasMultiTouchMove = false;
  this.hasSingleTouchMove = false;
  this.MultiTouchStartHandler = null;
  this.TouchStartHandler = null;
  this.MultiTouchMoveHandler = null;
  this.TouchMoveHandler = null;
  this.MultiTouchEndHandler = null;
  this.TouchEndHandler = null;
  this.sourceDistance = -1;
  this.zoomRatio = 1;
  this.touchStartX1 = 0;
  this.touchStartY1 = 0;
  this.lastTouchStartX1 = 0;
  this.lastTouchStartY1 = 0;
  this.touchStartCenterX = 0;
  this.touchStartCenterY = 0;
  this.touchMoveCenterX = 0;
  this.touchStartCenterY = 0;
  this.lastTriggerTouchEndTime = new Date();
  this.State = "Ready";
  this.EventArgs = {};

  this.Attach = function (element) {
    if (element == null) {
      alert("TouchEventManager.Attach() : element can not be null !");
      return;
    }

    this.Element = element;

    try {
      if (element.addEventListener != null) {
        element.addEventListener("touchstart", this.OnTouchStart.bind(this));
        element.addEventListener("touchend", this.OnTouchEnd.bind(this));
        element.addEventListener("touchmove", this.OnTouchMove.bind(this));
        element.addEventListener("touchleave", this.OnTouchEnd.bind(this));
        element.addEventListener("touchcancel", this.OnTouchEnd.bind(this));
      } else {
        alert("element.addEventListener is not defined ");
      }
    } catch (e) {
      alert("AttachTouchEvent:" + e);
    }
  };

  this.OnTouchStart = function (e) {
    var element;
    var touchStartX1 = 0;
    var touchStartX2 = 0;
    var touchStartY1 = 0;
    var touchStartY2 = 0;
    var touchStartEvent;

    if (this.State != "Ready") {
      return;
    }

    this.needPreventDefault = false;
    element = e.currentTarget;

    if (element != null && element.getAttribute("PreventDefault") == "true") {
      this.needPreventDefault = true;
    }

    element = e.currentTarget;
    this.ElementStartX = Utility.GetClientLeft(this.Element);
    this.ElementStartY = Utility.GetClientTop(this.Element);
    this.ElementStartWidth = this.Element.clientWidth;
    this.ElementStartHeight = this.Element.clientHeight;

    if (e.touches.length > 1) {
      //雙指觸控開始
      touchStartX1 = e.touches[0].screenX;
      touchStartY1 = e.touches[0].screenY;
      touchStartX2 = e.touches[1].screenX;
      touchStartY2 = e.touches[1].screenY;
      this.ElementStartCenterX = this.ElementStartX + this.ElementStartWidth / 2;
      this.ElementStartCenterY = this.ElementStartY + this.ElementStartHeight / 2;
      element.setAttribute("TouchStartX1", touchStartX1);
      element.setAttribute("TouchStartY1", touchStartY1);
      element.setAttribute("TouchStartX2", touchStartX2);
      element.setAttribute("TouchStartY2", touchStartY2);
      this.touchStartCenterX = (touchStartX1 + touchStartX2) / 2;
      this.touchStartCenterY = (touchStartY1 + touchStartY2) / 2;
      this.OffsetX = this.touchStartCenterX - this.ElementStartCenterX;
      this.OffsetY = this.touchStartCenterY - this.ElementStartCenterY;
      this.sourceDistance = Math.pow(Math.pow(touchStartX1 - touchStartX2, 2) + Math.pow(touchStartY1 - touchStartY2, 2), 0.5);
      element.setAttribute("TouchStartCenterX", (touchStartX1 + touchStartX2) / 2);
      element.setAttribute("TouchStartCenterY", (touchStartY1 + touchStartY2) / 2);

      if (this.MultiTouchStartHandler != null) {
        var _this$MultiTouchStart;

        this.MultiTouchStartHandler(e, (_this$MultiTouchStart = {
          Element: this.Element,
          TouchStartX1: touchStartX1,
          TouchStartY1: touchStartY1,
          TouchStartX2: touchStartX2
        }, _defineProperty(_this$MultiTouchStart, "TouchStartX2", touchStartY2), _defineProperty(_this$MultiTouchStart, "CenterX", this.touchStartCenterX), _defineProperty(_this$MultiTouchStart, "CenterY", this.touchStartCenterY), _this$MultiTouchStart));
      }
    } else {
      //單指觸控開始
      touchStartEvent = document.createEvent("CustomEvent");
      touchStartX1 = e.touches[0].screenX;
      touchStartY1 = e.touches[0].screenY;
      this.touchStartX1 = touchStartX1;
      this.touchStartY1 = touchStartY1;
      this.lastTouchStartX1 = this.touchStartX1;
      this.lastTouchStartY1 = this.touchStartY1;
      this.ElementStartCenterX = touchStartX1;
      this.ElementStartCenterY = touchStartY1;
      this.touchStartCenterX = touchStartX1;
      this.touchStartCenterY = touchStartY1;
      this.OffsetX = this.touchStartCenterX - this.ElementStartCenterX;
      this.OffsetY = this.touchStartCenterY - this.ElementStartCenterY;
      element.setAttribute("TouchStartX1", touchStartX1);
      element.setAttribute("TouchStartY1", touchStartY1);
      element.setAttribute("TouchStartCenterX", touchStartX1);
      element.setAttribute("TouchStartCenterY", touchStartY1);

      if (this.TouchStartHandler != null) {
        this.TouchStartHandler(e, {
          Element: this.Element,
          TouchStartX: touchStartX1,
          TouchStartY: touchStartY1,
          CenterX: touchStartX1,
          CenterY: touchStartY1
        });
      }
    }

    if (this.needPreventDefault) {
      e.preventDefault();
    }
  }; //end  this.OnTouchStart = function (e) {


  this.OnTouchMove = function (e) {
    var element;
    var touchStartX1 = 0;
    var touchStartY1 = 0;
    var touchStartX2 = 0;
    var touchStartY2 = 0;
    var touchMoveX1 = 0;
    var touchMoveY1 = 0;
    var touchMoveX2 = 0;
    var touchMoveY2 = 0;
    var moveX = 0,
        moveY = 0;
    var touchMoveEvent;
    var currentDistance = 0;
    var centerX, centerY;
    var offsetX, offsetY;
    element = e.currentTarget;

    try {
      if (e.changedTouches == null) {
        return;
      }

      this.State = "Touching";
      touchStartX1 = element.getAttribute("TouchStartX1");
      touchStartY1 = element.getAttribute("touchStartY1");

      if (e.changedTouches.length >= 2) {
        this.hasMultiTouchMove = true;
        this.lastMultiTouchMoveTime = new Date();
        touchMoveX1 = e.touches[0].screenX;
        touchMoveY1 = e.touches[0].screenY;
        touchMoveX2 = e.touches[1].screenX;
        touchMoveY2 = e.touches[1].screenY;
        this.lastTouchStartX1 = touchMoveX1;
        this.lastTouchStartY1 = touchMoveX1;
        this.needPreventDefault = true;
        element.setAttribute("TouchMoveX1", touchMoveX1);
        element.setAttribute("TouchMoveY1", touchMoveY1);
        element.setAttribute("TouchMoveX2", touchMoveX2);
        element.setAttribute("TouchMoveY2", touchMoveY2);
        currentDistance = Math.pow(Math.pow(touchMoveX1 - touchMoveX2, 2) + Math.pow(touchMoveY1 - touchMoveY2, 2), 0.5);

        if (this.sourceDistance > 0) {
          this.zoomRatio = currentDistance / this.sourceDistance;
        } else {
          this.zoomRatio = 1;
        }

        if (this.hasSingleTouchMove == false) {
          moveX = (touchMoveX1 + touchMoveX2) / 2 - this.ElementStartCenterX;
          moveY = (touchMoveY1 + touchMoveY2) / 2 - this.ElementStartCenterY;

          if (isNaN(moveX)) {
            alert(touchMoveX1 + "," + touchMoveX1 + "\r\n" + touchMoveY1 + "," + touchMoveY2);
          }
        } else {
          moveX = touchMoveX1 - this.touchStartX1;
          moveY = touchMoveY1 - this.touchStartY1;
        }

        if (this.MultiTouchMoveHandler != null) {
          //if (this.hasSingleTouchMove == true) {
          //    alert(" MultiTouchMoveHandler : this.hasSingleTouchMove==true");
          //}
          this.MultiTouchMoveHandler(e, {
            Element: this.Element,
            TouchStartX1: touchStartX1,
            TouchStartY1: touchStartY1,
            TouchStartX2: touchStartX2,
            TouchStartY2: touchStartY2,
            TouchMoveX1: touchMoveX1,
            TouchMoveY1: touchMoveY1,
            TouchMoveX2: touchMoveX2,
            TouchMoveY2: touchMoveY2,
            TouchCount: e.changedTouches.length,
            MoveX: moveX,
            MoveY: moveY,
            ZoomRatio: this.zoomRatio
          });
        }
      } else if (e.touches.length > 0) {
        if (!this.hasMultiTouchMove) {
          //需不曾有雙指拖曳過
          this.hasSingleTouchMove = true;
          touchMoveX1 = e.touches[0].screenX;
          touchMoveY1 = e.touches[0].screenY;

          if (Math.abs(touchMoveX1 - touchStartX1) > Math.abs(touchMoveY1 - touchStartY1)) {
            this.needPreventDefault = true;
          } else {
            this.needPreventDefault = false;
          }

          element.setAttribute("TouchMoveX1", touchMoveX1);
          element.setAttribute("TouchMoveY1", touchMoveY1);
          touchMoveX1 = e.touches[0].screenX;
          touchMoveY1 = e.touches[0].screenY;
          this.lastTouchStartX1 = touchMoveX1;
          this.lastTouchStartY1 = touchMoveX1;
          moveX = touchMoveX1 - this.touchStartCenterX;
          moveY = touchMoveY1 - this.touchStartCenterY;

          if (this.TouchMoveHandler != null) {
            this.TouchMoveHandler(e, {
              Element: this.Element,
              TouchStartX: touchStartX1,
              TouchStartY: touchStartY1,
              MoveX: moveX,
              MoveY: moveY,
              TouchCount: e.changedTouches.length,
              ZoomRatio: this.zoomRatio
            });
          }
        }
      }

      if (this.needPreventDefault) {//  e.preventDefault();
      }
    } catch (e) {
      alert(e);
    }
  }; //end this.OnTouchMove = function (e) {


  this.OnTouchEnd = function (e) {
    var _this = this;

    var element;
    var touchStartX1 = 0;
    var touchStartY1 = 0;
    var touchStartX2 = 0;
    var touchStartY2 = 0;
    var touchMoveX1 = 0;
    var touchMoveY1 = 0;
    var touchMoveX2 = 0;
    var touchMoveY2 = 0;
    var moveX = 0,
        moveY = 0;
    var touchMoveEvent;
    var currentDistance = 0;
    var centerX, centerY;
    var offsetX, offsetY;
    var currentTime = new Date();

    if (e.touches.length > 0) {
      //尚有手指在螢幕上
      return;
    }

    if (currentTime - this.lastTriggerTouchEndTime < 100) {
      return;
    }

    this.lastTriggerTouchEndTime = new Date();
    this.State = "Ready";
    this.currentDistance = -1;
    this.zoomRatio = 1;
    this.sourceDistance = -1;
    this.hasMultiTouchMove = false;
    this.hasSingleTouchMove = false;
    element = e.currentTarget;

    try {
      this.State = "Ready";
      moveX = this.lastTouchStartX1 - this.touchStartCenterX;
      moveY = this.lastTouchStartY1 - this.touchStartCenterY;

      if (this.TouchEndHandler != null) {
        setTimeout(function () {
          _this.TouchEndHandler(e, {
            Element: _this.Element,
            TouchStartX: _this.lastTouchStartX1,
            TouchStartY: _this.lastTouchStartY1,
            MoveX: moveX,
            MoveY: moveY
          });
        }, 1);
      }
    } catch (e) {
      alert(e);
    }
  }, this.GetTouchThresholdByDeviceWidth = function () {
    var deviceWidth;
    var threshold = 100;
    deviceWidth = document.documentElement.clientWidth;

    if (deviceWidth <= 300) {
      threshold = 30;
    } else if (deviceWidth <= 500) {
      threshold = 60;
    } else if (deviceWidth <= 800) {
      threshold = 100;
    } else if (deviceWidth <= 1300) {
      threshold = 100;
    } else {
      threshold = 100;
    }

    return threshold;
  };
} //end function TouchEventManager(){


export default TouchEventManager;